<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="用户信息：" prop="keyword">
            <el-input v-model="query.keyword" placeholder="请输入姓名/手机号" size="small" clearable />
          </el-form-item>
          <el-form-item label="部门：">
            <el-select v-model="query.deptId" placeholder="请选择" clearable size="small">
              <el-option :label="item.value" :value="item.key" v-for="item in sectionList" :key="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="query.timeType" placeholder="请选择" clearable size="small">
              <el-option label="入职时间" :value="1"></el-option>
              <el-option label="修改时间" :value="2"></el-option>
              <el-option label="离职时间" :value="3"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="doQueryList({pageNo:1})">
          <el-tab-pane label="在职" name="1"></el-tab-pane>
          <el-tab-pane label="离职" name="0"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate(0,'')" icon="el-icon-plus" v-hasPermi="['interior:employee:add']">新建内部人员</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" :key="activeName">
        <el-table-column label="id" prop="id" align="center" fixed />
        <el-table-column label="姓名" prop="realName" align="center" fixed>
          <template slot-scope="{row}">
            <div @click="handleShowDetail(row.id)">
              <el-link type="primary">{{row.realName}}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="userPho" align="center" fixed />
        <el-table-column label="部门" prop="deptName" align="center" />
        <el-table-column label="入职时间" prop="entryTime" sortable align="center" width="200" v-if="activeName=='1'" />
        <el-table-column label="离职时间" prop="resignationTime" sortable align="center" width="200" v-if="activeName=='0'" />
        <el-table-column label="修改时间" prop="operatedTime" sortable align="center" width="200" />
        <el-table-column label="操作人" prop="operator" align="center" />
        <el-table-column label="操作" align="center" fixed="right" width="280">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleCreate(1,row)" v-if="activeName=='1'" v-hasPermi="['interior:employee:edit']">编辑</el-button>
            <el-button type="text" @click="handleUpdate(row,1)" v-if="activeName=='1'" v-hasPermi="['interior:employee:setas']">设为离职</el-button>
            <el-button type="text" @click="handleUpdate(row,4)" v-if="activeName=='0'" v-hasPermi="['interior:employee:setas']">设为在职</el-button>
            <el-button type="text" @click="handleEntryInhibited(row)" v-if="row.entryInhibited">{{row.entryInhibited?'恢复登录':'禁止登录'}}</el-button>
            <el-button type="text" @click="handleClearCache(row)">清除缓存</el-button>
            <el-button type="text" @click="handleUpdate(row,3)">日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <city-add ref="cityAdd" @created="doQueryList({})" :sectionList="sectionList" :popType="popType" />
  </div>
</template>

<script>
import sysDeptApi from '@/api/sys/sysDept'
import Pagination from '@/components/Pagination'
import userApi from '@/api/sys/user'
import cityAdd from './add'
import clientListApi from '@/api/client/clientList'
// import customerLevelApi from '@/api/sys/customerLevel'
export default {
  components: {
    Pagination,
    cityAdd
    // businessQuit,
    // businessAdjust,
    // areaRemove
  },
  data() {
    return {
      popType: null,
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        isInternal: 1
      },
      sectionList: [],
      dateTime: null,
      activeName: '1',
      optionNameList: [],
      optionPhoList: []
    }
  },
  created() {
    this.doQueryList({
      pageNo: 1
    })
    this.getOption()
    // this.getList()
  },
  methods: {
    // async getList(){
    //   const {data} = await clientListApi.listForMini({CLevel:8})
    //   // console.log('data',data)
    //   this.optionNameList=data.map(i=>({"value":i.name,"value2":i.pho}))
    //   this.optionPhoList=data.map(i=>({"value":i.pho,"value2":i.name}))
    //   // console.log('this.optionNameList: ',this.optionNameList,this.optionPhoList);
    // },
    handleClearCache(row) {
      this.$common.confirm('是否确认清除缓存')
        .then(() => userApi.delCache({userId: row.id}))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    handleEntryInhibited(row) {
      this.$common.confirm(row.entryInhibited ? '是否确认恢复登录' : '是否确认禁止用户登录，禁用了客户不能登录app').then(
        async () => {
          await userApi.updateEntryInhibited({
            entryInhibited: row.entryInhibited == 1 ? 0 : 1,
            id: row.id
          })
        }).then(() => {
          this.$common.showMsg('success', `${row.entryInhibited ? '恢复' : '禁止'}成功`)
          this.doQueryList({ pageNo: 1 })
        })
    },
    handleUpdate(row, type) {
      if (type == 2) {
        this.popType = 2
        this.$refs.cityAdd.handleUpdate(row)
      }
      if ([1, 4].includes(type)) {
        this.$common.confirm(type == 1 ? '是否确认提交离职，离职后该内部员工无法享受内部权益' : '是否确认提交入职').then(() => {
          userApi.updateJobStatus({ id: row.id, jobStatus: type == 1 ? 0 : 1 }).then((res) => {
            this.$message.success('操作成功')
            this.doQueryList({ pageNo: 1 })
          })
        })
          .then(() => {
            this.doQueryList({ pageNo: 1 })
          })
      }
      if (type == 3) {
        this.$router.push("/log/log?type=55&id=" + row.id);
      }
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        isInternal: 1
      }
      this.dateTime = []
      this.doQueryList({
        pageNo: 1
      })
    },
    // 获取部门
    getOption() {
      sysDeptApi.findOptions().then(({ data }) => {
        this.sectionList = data
      })
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.jobStatus = this.activeName == 1 ? 1 : 0
      let query = {
        ...this.query,
      }

      if (this.query.timeType == 1 && this.dateTime) {
        query.entryTimeStart = this.dateTime[0]
        query.entryTimeEnd = this.dateTime[1]
      }
      if (this.query.timeType == 2 && this.dateTime) {
        query.operatedTimeStart = this.dateTime[0]
        query.operatedTimeEnd = this.dateTime[1]
      }
      if (this.query.timeType == 3 && this.dateTime) {
        query.resignationTimeStart = this.dateTime[0]
        query.resignationTimeEnd = this.dateTime[1]
      }
      delete query.timeType
      // if(!)
      this.listLoading = true
      return userApi.fetchList(query)
        .then(({
          data
        }) => {
          console.log("data: ", data);
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 打开新建、编辑表单
     */
    handleCreate(type, row) {
      this.popType = type
      if (!type) {
        this.$refs.cityAdd.handleCreate()
      } else {
        this.$refs.cityAdd.handleUpdate(row)
      }
    },
    //查看信息
    handleShowDetail(id) {
      this.$emit('handleShow', id, 2)
    },
  }
}
</script>
